import React, { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { CellProps, Column } from 'react-table';
import { TableDraggableRows } from '../../../../../../components/CiscoUi';
import {
  setDelaySecondsOnBlur,
  setDelaySecondsOnChange,
} from '../../../../../../redux/configuration/start-stop-order/slice';
import { StartStopDelayInput } from '../../components/StartStopDelayInput';
import { VMStartTableProps } from '../../VMStart/components/VMStartTable';
import styles from './HardwareStartTable.module.css';

export type HardwareStartTableProps = VMStartTableProps;

export function HardwareStartTable({
  handleOnRowDrag,
  positions,
}: HardwareStartTableProps): ReactElement {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const columns = useMemo<Column<StartStopOrderPosition>[]>(
    () => [
      {
        Header: () => t('startStopOrder.hardwareStart.table.headings.name'),
        accessor: (row) => row.hardwareItem?.name,
        disableSortBy: true,
        id: 'name',
      },
      {
        // eslint-disable-next-line react/display-name
        Cell: ({
          row: { original },
          value,
        }: CellProps<StartStopOrderPosition>) => (
          <StartStopDelayInput
            onChange={(e) => {
              dispatch(
                setDelaySecondsOnChange({
                  delaySeconds: e.target.value,
                  position: original.position,
                }),
              );
            }}
            onBlur={(e) => {
              dispatch(
                setDelaySecondsOnBlur({
                  delaySeconds: e.target.value,
                  position: original.position,
                }),
              );
            }}
            value={value}
          />
        ),
        Header: () => t('startStopOrder.vmStart.table.headings.delay'),
        accessor: (row) => row.delaySeconds,
        id: 'delay',
      },
    ],
    [dispatch, t],
  );

  return (
    <TableDraggableRows<StartStopOrderPosition>
      className={styles.root}
      columns={columns}
      data={positions}
      handleOnRowDrag={handleOnRowDrag}
    />
  );
}
